export const WS_SERVER = `wss://prelease.shenlan.trailerman.cn/v1/websocket`;
export const SERVER = `https://prelease.shenlan.trailerman.cn`;
// export const WS_SERVER = `ws://${'192.168.2.19:9191'}/v1/websocket`;
// export const SERVER = "http://192.168.2.171:9191";
// export const WS_SERVER = `wss://develop.applet.trailerman.cn/v1/websocket`;
// export const SERVER = `https://develop.applet.trailerman.cn`;